import PopupFormWrapper from "../popupFormWrapper";

const FORM_CODE = "message";

export default function Message() {
  return <PopupFormWrapper code={FORM_CODE} />;
}
